var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.625c2.661 0 4.85 2.189 4.85 4.875s-2.189 4.875-4.85 4.875c-2.711 0-4.9-2.189-4.9-4.875S9.289 1.625 12 1.625zM12 13c3.565 0 6.475-2.91 6.475-6.5S15.565 0 12 0C8.385 0 5.475 2.91 5.475 6.5S8.385 13 12 13zm9.725 10.563a.821.821 0 0 1-.813.812H3c-.41 0-.775-.375-.775-.813V21.45c0-2.87 2.33-5.2 5.2-5.2.995 0 1.986.813 4.575.813 2.534 0 3.53-.813 4.525-.813 2.87 0 5.2 2.33 5.2 5.2zm-5.2-8.938c-1.457 0-2.158.813-4.525.813-2.417 0-3.113-.813-4.575-.813A6.827 6.827 0 0 0 .6 21.45v2.112C.6 24.909 1.692 26 3 26h17.912a2.438 2.438 0 0 0 2.438-2.438V21.45a6.827 6.827 0 0 0-6.825-6.825z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8f5f68aeed03389a90c85440930e4c44.svg";
export { ForwardRef as ReactComponent };